module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/notes/notes.component.css
// module id = ./src/app/notes/notes.component.css
// module chunks = main